import { FC, SVGAttributes } from 'react';

type QuestionSvgProps = SVGAttributes<SVGElement>;

export const QuestionSvg: FC<QuestionSvgProps> = (props) => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M6.60396 9.81497L7.24145 7.05257C9.58017 7.26901 10.7279 7.1208 10.905 6.35346C11.0821 5.58613 10.1442 5.13622 9.1552 4.90798C7.62054 4.55382 6.18687 4.85157 4.83059 5.67005L3.30118 3.03619C5.12048 2.00128 7.19032 1.43727 9.95271 2.07476C12.8686 2.74766 15.7923 4.55386 15.1824 7.1969C14.7101 9.24311 12.5774 9.84648 9.99728 9.43066L9.7415 10.539L6.60396 9.81497ZM7.10369 14.6538C5.75659 14.3429 5.03255 13.2778 5.28833 12.1694C5.54018 11.0781 6.66167 10.421 8.00876 10.7318C9.33881 11.0388 10.0589 12.1209 9.80707 13.2122C9.55128 14.3206 8.43373 14.9607 7.10369 14.6538Z"
                fill="#F3A900"
            />
        </svg>
    );
};
